export default "__VITE_ASSET__27e788a6__"